export interface LoginRouteFromState {
  readonly pathname?: string
  readonly search?: string
}

/** Post-login navigation target (S3358 — no nested ternary in LoginPage). */
export function loginReturnPath(
  pendingClaim: boolean,
  from: LoginRouteFromState | undefined,
): string {
  if (pendingClaim) {
    return '/rewards?from=signup-survey'
  }
  if (from?.pathname == null) {
    return '/'
  }
  return `${from.pathname}${from.search ?? ''}`
}

export function loginSuccessNavigateState(
  pendingClaim: boolean,
  from: LoginRouteFromState | undefined,
): { loginSuccess: true } | undefined {
  if (from?.pathname == null && !pendingClaim) {
    return { loginSuccess: true }
  }
  return undefined
}
